import FinalCTA from "../../components/layout/FinalCTA";
import PageSEO from "../../components/PageSEO";
import ContactFAQ from "./ContactFAQ";
import ContactHero from "./ContactHero";
import ContactMap from "./ContactMap";

export default function Contact() {
  return (
    <>
      <PageSEO
        title="Contact Vision X Nexus | Real Estate Consultants in Dubai & Sharjah"
        description="Get in touch with Vision X Nexus Real Estate L.L.C for expert property advice in Dubai, Sharjah, and Ajman. Call, email, or visit our Sharjah office."
        canonical="https://visionxnexus.com/contact"
        pageName="Contact Vision X Nexus"
        faqs={[
          {
            question: "How can I contact Vision X Nexus?",
            answer:
              "You can contact us via phone, email, or by visiting our office in Sharjah.",
          },
          {
            question: "Do you offer free consultations?",
            answer:
              "Yes, our initial real estate consultation is complimentary.",
          },
        ]}
      />
      <ContactHero />
      <ContactMap />
      <ContactFAQ />
      <FinalCTA />
    </>
  );
}
